import React, { useMemo, useState } from 'react';
import { SectionHeading } from '../SectionHeading';
import { Carousel } from '../Carousel';
import { ZoomableImage } from '../ZoomableImage';
import { GALLERY, VOLUMES } from '../../data/catio';
type Filter = 'all' | string;

/** 15 real project previews, filterable by volume. */
export function GallerySection() {
  const [filter, setFilter] = useState<Filter>('all');
  const items = useMemo(() => filter === 'all' ? GALLERY : GALLERY.filter(p => p.volume === filter), [filter]);
  const tabs: Array<{
    id: Filter;
    label: string;
  }> = [{
    id: 'all',
    label: 'All 15'
  }, ...VOLUMES.map(v => ({
    id: v.number,
    label: `Vol ${v.number}`
  }))];
  return <section id="gallery" aria-labelledby="gallery-title" className="bg-ink py-12 sm:py-20" data-id="element-187" data-mp="2zpi13pbarod">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-188" data-mp="22cth8vpwcwq3">
        <SectionHeading id="gallery-title" tone="dark" title="Preview 15 of the 40 Included Designs" lead="Explore selected projects from all five volumes. The complete collection includes 40 projects." data-id="element-189" data-mp="22a78wtv6md6t" />

        <div role="tablist" aria-label="Filter projects by volume" className="no-scrollbar -mx-5 mt-7 flex gap-2 overflow-x-auto px-5 sm:mx-0 sm:mt-9 sm:px-0" data-id="element-190" data-mp="r9vb1tsk892k">
          {tabs.map(tab => {
          const selected = tab.id === filter;
          return <button key={tab.id} type="button" role="tab" aria-selected={selected} aria-controls="gallery-panel" onClick={() => setFilter(tab.id)} className={`label-tech min-h-[42px] shrink-0 whitespace-nowrap rounded-full border px-4 transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-ember/40 ${selected ? 'border-paper bg-paper text-ink' : 'border-cream/20 text-cream/75 hover:border-cream/50'}`} data-id="element-191" data-mp="15yrippqpfk2n">
                {tab.label}
              </button>;
        })}
        </div>

        <div id="gallery-panel" role="tabpanel" className="mt-6" data-id="element-192" data-mp="1yidfobvkycyw">
          <Carousel items={items} getKey={project => `${filter}-${project.src}`} label="Real CATIO READY™ project previews" tone="dark" itemClassName="w-[80%] sm:w-[44%] lg:w-[31%]" renderItem={project => <figure className="flex w-full flex-col" data-id="element-194" data-mp="1fsnkhnnwnp6g">
                <ZoomableImage image={project} tone="dark" className="overflow-hidden rounded-[10px] ring-1 ring-white/10" imgClassName="aspect-[1530/1980] w-full object-cover" data-id="element-195" data-mp="1aultmgk8mlkf" />
                <figcaption className="mt-3 flex items-baseline justify-between gap-3" data-id="element-196" data-mp="11t4eb0enmnws">
                  <span className="font-display text-[1.08rem] leading-snug text-cream" data-id="element-197" data-mp="wvcp4e5e9fwa">
                    {project.title}
                  </span>
                  <span className="label-tech shrink-0 text-ember-light" data-id="element-198" data-mp="3dh0vipvx91vn">
                    Vol {project.volume}
                  </span>
                </figcaption>
              </figure>} data-id="element-193" data-mp="1tjsi6k7pq7e5" />
        </div>
      </div>
    </section>;
}